import { dimensions, SvgIconProps } from "./SvgIcon";

export const CompareWithIcon = (props: SvgIconProps) => {
  const { width, height } = dimensions(props);
  return (
    <svg
      style={{ display: "block", ...props.style }}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7711_44374)">
        <path
          d="M1.00003 9.00057C0.802281 9.00053 0.608982 8.94186 0.444573 8.83197C0.280163 8.72209 0.152023 8.56592 0.0763531 8.38322C0.000683047 8.20052 -0.0191199 7.99949 0.0194476 7.80554C0.0580152 7.61158 0.153222 7.43342 0.293031 7.29357L3.79303 3.79357C3.98056 3.6061 4.23487 3.50078 4.50003 3.50078C4.7652 3.50078 5.0195 3.6061 5.20703 3.79357L7.50003 6.08657L10.293 3.29357C10.3853 3.19806 10.4956 3.12188 10.6176 3.06947C10.7396 3.01706 10.8709 2.98947 11.0036 2.98832C11.1364 2.98717 11.2681 3.01247 11.391 3.06275C11.5139 3.11303 11.6255 3.18728 11.7194 3.28117C11.8133 3.37507 11.8876 3.48672 11.9379 3.60962C11.9881 3.73251 12.0134 3.86419 12.0123 3.99697C12.0111 4.12975 11.9835 4.26097 11.9311 4.38297C11.8787 4.50498 11.8025 4.61532 11.707 4.70757L8.20703 8.20757C8.0195 8.39504 7.7652 8.50036 7.50003 8.50036C7.23487 8.50036 6.98056 8.39504 6.79303 8.20757L4.50003 5.91457L1.70703 8.70757C1.51954 8.89512 1.26523 9.00051 1.00003 9.00057Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_7711_44374">
          <rect width="12" height="12" fill="transparent" />
        </clipPath>
      </defs>
    </svg>
  );
};
